import Api from '@/services/Api'

export default {
    leaRazones(){
        return Api().get('leaRazones')
    },
    grabaRazon(forma){
        return Api().post('grabaRazon',forma)
    },
    actualizaRazon(forma){
        return Api().post('actualizaRazon',forma)
    },
    borraRazon(id){
        return Api().post('borraRazon/'+id)
    },
}
